export enum GenderType {
    CHOOSE = 'E',
    WOMAN = 'M',
    MAN = 'H',
}
